var map = {
	"./Al_Wasiyyat_Logo.png": 664,
	"./Al_Wasiyyat_LogoN.png": 228,
	"./Apple.png": 107,
	"./Bahar.jpg": 643,
	"./Bahar.png": 227,
	"./Google.png": 142,
	"./Group407.png": 67,
	"./MarketingManager.jpeg": 519,
	"./ProjectLead.jpg": 690,
	"./QRapps.jpeg": 295,
	"./Safayet.jpg": 212,
	"./Wasiyyah.jpeg": 475,
	"./Wasiyyah2.jpeg": 443,
	"./bd.png": 49,
	"./fahad-vai-image.jpeg": 667,
	"./family.jpg": 371,
	"./logo.png": 806,
	"./logo2.png": 886,
	"./mosjid.jpg": 215,
	"./pen-alt.png": 592,
	"./rajib.jpg": 645,
	"./usa.png": 505,
	"./wasiyyah-logo.png": 140,
	"./wasiyyah.png": 346,
	"./wasyyah_logo.jpeg": 480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;